var map = {
	"./accounts-icon-white.png": 1711,
	"./accounts-icon.png": 1712,
	"./add-icon-blue.png": 121,
	"./add-icon-white.png": 312,
	"./add-icon.png": 68,
	"./agregar-efectivo.png": 918,
	"./back-blue-arrow.png": 1713,
	"./bank-icon-white.png": 1714,
	"./bank-icon.png": 1715,
	"./bar-icon.png": 1716,
	"./billete1.png": 511,
	"./billete10.png": 512,
	"./billete100.png": 513,
	"./billete20.png": 514,
	"./billete200.png": 515,
	"./billete5.png": 516,
	"./billete50.png": 517,
	"./bodega-ajuste.png": 919,
	"./bodega-baja.png": 920,
	"./bodega-icon-white.png": 1717,
	"./bodega-icon.png": 1718,
	"./bodega-ingreso.png": 921,
	"./box-icon-white.png": 518,
	"./cancel-icon-white.png": 313,
	"./cancel-sale-icon-gris.png": 922,
	"./car-shop-icon.png": 519,
	"./cash-box-icon-white.png": 1719,
	"./cash-box-icon.png": 1720,
	"./cash-box.png": 923,
	"./cashBox.png": 924,
	"./cashBoxActive.png": 925,
	"./categories-icon-white.png": 1721,
	"./categories-icon.png": 1722,
	"./check-icon-green.png": 372,
	"./check-patient-icon.png": 520,
	"./clear-icon-white.png": 926,
	"./cobrar-icon-blue-antiguo.png": 1723,
	"./cobrar-icon-blue.png": 314,
	"./configuration-icon-white.png": 1724,
	"./configuration-icon.png": 1725,
	"./consult-icon-white.png": 1726,
	"./consult-icon.png": 1727,
	"./cuenta-abierta-gris.png": 521,
	"./cupon-icon-gris.png": 927,
	"./cupon.png": 1728,
	"./delete-icon.png": 46,
	"./delete-patient-icon.png": 122,
	"./down-arrow-icon.png": 928,
	"./down-arrow-white-icon.png": 146,
	"./edit-icon-blue-2.png": 1729,
	"./edit-icon-blue.png": 1730,
	"./edit-icon.png": 373,
	"./empty-check-blue.png": 929,
	"./fill-check-blue.png": 930,
	"./history-icon-orange.png": 315,
	"./history-icon-white.png": 374,
	"./home-icon-white.png": 1731,
	"./home-icon.png": 1732,
	"./igss-black.png": 1733,
	"./igss-gray.png": 1734,
	"./institution-icon-white.png": 1735,
	"./institution-icon.png": 1736,
	"./lefth-arrow-icon.png": 931,
	"./lock-icon.png": 917,
	"./logged-user-icon.png": 932,
	"./moneda1.png": 522,
	"./moneda10.png": 523,
	"./moneda1c.png": 524,
	"./moneda25.png": 525,
	"./moneda5.png": 526,
	"./moneda50.png": 527,
	"./notification-icon.png": 933,
	"./off-switch.png": 1737,
	"./ojo-circular-derecho-azul.png": 1738,
	"./ojo-circular-derecho-gris.png": 934,
	"./ojo-circular-derecho-mod-azul.png": 935,
	"./ojo-circular-izquierdo-azul.png": 1739,
	"./ojo-circular-izquierdo-gris.png": 936,
	"./ojo-circular-izquierdo-mod-azul.png": 937,
	"./ojo-derecho-azul.png": 938,
	"./ojo-derecho-gris.png": 939,
	"./ojo-derecho-ramas-azul.png": 940,
	"./ojo-izquierdo-azul.png": 941,
	"./ojo-izquierdo-gris.png": 528,
	"./ojo-izquierdo-ramas-azul.png": 942,
	"./on-switch.png": 1740,
	"./order-icon-white.png": 529,
	"./order-icon.png": 1741,
	"./package-icon-2.png": 1742,
	"./package-icon-green.png": 530,
	"./package-icon.png": 531,
	"./password-eye-icon.png": 1743,
	"./password-slash-eye-icon.png": 1744,
	"./patients-icon-white.png": 1745,
	"./patients-icon.png": 1746,
	"./pausa-icon-blue.png": 943,
	"./payback_payment_icon.png": 532,
	"./pdf.png": 914,
	"./plan-icon-white.png": 1747,
	"./plan-icon.png": 1748,
	"./print-icon-white.png": 375,
	"./products-icon-white.png": 1749,
	"./products-icon.png": 1750,
	"./provider-icon-white.png": 1751,
	"./provider-icon.png": 1752,
	"./puntero-icon.png": 944,
	"./reference-icon-white.png": 1753,
	"./reference-icon.png": 1754,
	"./referents-icon-white.png": 1755,
	"./referents-icon.png": 1756,
	"./reports-icon-white.png": 1757,
	"./reports-icon.png": 1758,
	"./retirar-efectivo.png": 1759,
	"./return-icon-blue.png": 316,
	"./return-icon-white.png": 187,
	"./review.png": 945,
	"./right-arrow-icon.png": 946,
	"./right-arrow-white-icon.png": 1760,
	"./round-check-icon.png": 1761,
	"./sales-icon-white.png": 1762,
	"./sales-icon.png": 1763,
	"./save-icon-gris.png": 533,
	"./save-icon-white.png": 947,
	"./schedule-icon-white.png": 1764,
	"./schedule-icon.png": 1765,
	"./search-icon.png": 534,
	"./service-icon-green.png": 535,
	"./service-icon.png": 536,
	"./set-account.png": 537,
	"./start-icon-blue.png": 1766,
	"./start-icon-white.png": 948,
	"./stop-icon-blue.png": 949,
	"./task-icon-white.png": 1767,
	"./task-icon.png": 1768,
	"./undo-icon-white.png": 950,
	"./up-arrow-icon.png": 951,
	"./up-arrow-white-icon.png": 147,
	"./user-icon.png": 916,
	"./users-icon-white.png": 1769,
	"./users-icon.png": 1770,
	"./view-icon.png": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1710;